<template>
  <div v-if="assist.tool.isNotEmpty(questionTemplate)" class="section-question">
    <v-divider class="no-bg m-v-5"></v-divider>
    <v-layout row>
      <v-flex lg12>
        <ul class="fa-ul m-0">
          <template v-for="(questionTemplate, index) in dataSource.questionTemplateData">
            <li :key="assist.tool.getRandomKey(index)">
                <span class="fa-li">
                  <i class="fad fa-caret-right"></i>
                </span>
              {{ questionTemplate.question }}
              <span class="m-l-10">
                  <b>{{ assist.tool.isEmpty(dataSource.questionAnswerData[questionTemplate.id]) ? "N/A" : dataSource.questionAnswerData[questionTemplate.id].text }}</b>
                </span>
            </li>
          </template>
        </ul>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import { Tool } from '@/util/index'

const tool = new Tool()
export default {
  name: 'section-question',
  props: {
    questionTemplate: Array,
    questionAnswerData: Object
  },
  data () {
    return {
      dataSource: {
        questionTemplateData: [],
        questionAnswerData: {}
      },
      assist: {
        tool: tool
      }
    }
  },
  watch: {
    questionTemplate (val) {
      this.dataSource.questionTemplateData = val
    },
    questionAnswerData (val) {
      this.dataSource.questionAnswerData = val
    }
  }
}
</script>

<style lang="css" scoped>
.section-question {
  color: #222222
}
</style>
